import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Login from '../../pages/Login';
import { Home } from '../../pages/Home';
import { PersonalDossiers } from '../../pages/dossiers/PersonalDossiers';
import AccountSettings from '../../pages/AccountSettings';
import Logout from '../../pages/Logout';
import Documents from '../../pages/Documents';
import Chat from '../../pages/chat/Chat';
import PasswordForgotten from '../../pages/PasswordForgotten';
import { Tools } from '../../pages/measurements/Tools';
import Measurement from '../../pages/measurements/Measurement';
import NotificationPage from '../../pages/Notification';
import { MeasurementNew } from '../../pages/measurements/MeasurementNew';
import MeasurementOverview from '../../pages/measurements/MeasurementOverview';
import MeasurementUnanswered from '../../pages/measurements/MeasurementUnanswered';
import { SelectFile } from '../../pages/SelectFile';
import GuardedRoute from './GuardedRoute';
import Reports from '../../pages/reports/Reports';
import { AllDossiers } from '../../pages/dossiers/AllDossiers';
import ManageDossier from '../../pages/ManageDossier';
import PasswordReset from '../../pages/PasswordReset';
import { Library } from '../../pages/library/Library';
import { ERouterPath } from './ERouterPath';
import Appointments from '../../pages/appointments/Appointments';
import NewDossier from '../../pages/manage-dossiers/NewDossier';
import { NewPerson } from '../../pages/manage-persons/NewPerson';
import { ListPersons } from '../../pages/manage-persons/ListPersons';
import { AddPersonToDossier } from '../../pages/manage-dossiers/AddPersonToDossier';
import { UpdatePerson } from '../../pages/manage-persons/UpdatePerson';
import UpdateDossier from '../../pages/manage-dossiers/UpdateDossier';
import { Dossier } from '../../pages/Dossier';

export const publicPaths = [ERouterPath.logout, ERouterPath.passwordForgotten, ERouterPath.PasswordReset.replace('/:code', ''), ERouterPath.login];

const Router = (): JSX.Element => (
  <BrowserRouter>
    <Switch>
      <Route path={ERouterPath.login} exact component={Login} />
      <Route path={ERouterPath.logout} exact component={Logout} />
      <Route path={ERouterPath.passwordForgotten} exact component={PasswordForgotten} />
      <Route path={ERouterPath.PasswordReset} exact component={PasswordReset} />

      <GuardedRoute path={ERouterPath.allDossiers} exact component={AllDossiers} />
      <GuardedRoute path={ERouterPath.personalDossiers} exact component={PersonalDossiers} />
      <GuardedRoute path={ERouterPath.selectFile} exact component={SelectFile} />
      <GuardedRoute path={ERouterPath.accountSettings} exact component={AccountSettings} />
      <GuardedRoute path={ERouterPath.notification} exact component={NotificationPage} />
      <GuardedRoute path={ERouterPath.newPerson} exact component={NewPerson} />
      <GuardedRoute path={ERouterPath.updatePerson} exact component={UpdatePerson} />
      <GuardedRoute path={ERouterPath.listPersons} exact component={ListPersons} />
      <GuardedRoute path={ERouterPath.addPersonToDossier} exact component={AddPersonToDossier} />
      <GuardedRoute path={ERouterPath.newDossier} exact component={NewDossier} />

      <GuardedRoute path={ERouterPath.dossier} exact component={Dossier} requireDossier={true} />
      <GuardedRoute path={[ERouterPath.reports, ERouterPath.reportsClient, ERouterPath.reportsResponsible, ERouterPath.reportsShared]} exact component={Reports} requireDossier={true} />
      <GuardedRoute path={[ERouterPath.documents, ERouterPath.documentsOfUser]} exact component={Documents} requireDossier={true} />
      <GuardedRoute path={ERouterPath.appointments} exact component={Appointments} requireDossier={true} />
      <GuardedRoute path={[ERouterPath.chat, ERouterPath.chatConversation]} exact component={Chat} requireDossier={true} />
      <GuardedRoute path={ERouterPath.tools} exact component={Tools} requireDossier={true} />
      <GuardedRoute path={ERouterPath.measurement} exact component={Measurement} requireDossier={true} />
      <GuardedRoute path={ERouterPath.measurementNew} exact component={MeasurementNew} requireDossier={true} />
      <GuardedRoute path={ERouterPath.measurementOverview} exact component={MeasurementOverview} requireDossier={true} />
      <GuardedRoute path={ERouterPath.measurementUnanswered} exact component={MeasurementUnanswered} requireDossier={true} />
      <GuardedRoute path={ERouterPath.manageDossier} exact component={ManageDossier} requireDossier={true} />
      <GuardedRoute path={ERouterPath.updateDossier} exact component={UpdateDossier} requireDossier={true} />
      <GuardedRoute path={[ERouterPath.library, ERouterPath.libraryItemsForRelation]} exact component={Library} requireDossier={true} />

      <GuardedRoute path={ERouterPath.home} exact component={Home} />
      <GuardedRoute path="/" exact component={Home} />
    </Switch>
  </BrowserRouter>
);

export default Router;
